import { Breadcrumb, Table, Menu, Input, Tag, Dropdown, Button } from "antd";
import React, { Component } from "react";
import {
  FaArrowLeft,
  FaArrowRight,
  FaEllipsisH,
  FaEye,
  FaPen,
  FaPlus,
  FaPlusSquare,
  FaTrash,
  FaTrashAlt,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import { HomeOutlined } from "@ant-design/icons";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
const { Search } = Input;

const menu = (
  <Menu>
    <Menu.Item className="show-item" icon={<FaEye />}>
      <p>عرض </p>
    </Menu.Item>
    <Menu.Item  icon={<FaPlusSquare />}>
      <Link to="/finance">تعديل</Link>
    </Menu.Item>
    <Menu.Item className="remove-item" icon={<FaTrashAlt />}>
      <p>حذف </p>
    </Menu.Item>
  </Menu>
); 

export default class TeamInfo extends Component {
  state = {
    loading: false,
    showDltModal: false, 
    nameList : []
  };

  componentDidMount() {
    let data = [];

    for (let i = 0; i < 100; i++) {
        data.push({
            key: i,
            name: `محمد ابو سليمان`,
            orderId: 2213332123, 
            totalOrder: "ادمن",
            phone: 1008270540,
            email: "test@test@gmail.com",
            address: `London, Park Lane no. ${i}`,
            lastorder : "Wed Mar 24 2021 14:43:42"
        });
    }

    this.setState({ nameList: data })
}


itemRender = (current, type, originalElement) =>  {
  if (type === 'prev') {
    return <a className="prev-page-btn pagin-page-btn"><FaArrowRight />  الصفحة السابقة </a>;
  } 
  if (type === 'next') { 
    return <a className="next-page-btn pagin-page-btn">الصفحة التاليه  <FaArrowLeft /> </a>;
  }
  return originalElement;
}

closeDltModal = () => { 
  this.setState({showDltModal : false})
}

  render() {
    const { loading, tableLoading, showDltModal } = this.state;
    return (
      <div className="teams-inner-wrapper">
        {showDltModal && <DeleteModal name="الموظف" closeDltModal={this.closeDltModal} /> }
        <div className="header-img-holder">
          <div className="container">
            <div className="img-header">
              <div className="header-first">
                <Breadcrumb separator=">">
                  <Breadcrumb.Item>
                    <Link to="/">
                      <HomeOutlined />
                      <p className="link-name">الرئيسية</p>
                    </Link>
                  </Breadcrumb.Item>
                  <Breadcrumb.Item>
                    <Link to="/teams">
                      <p className="link-name">الفرق</p>
                    </Link>
                  </Breadcrumb.Item>
                  <Breadcrumb.Item className="last-bread">
                  عرض الفريق
                  </Breadcrumb.Item>
                </Breadcrumb>
                <h1 style={{ color : '#000' }}>فريق العروبه</h1>
              </div>
              <div className="header-sec">
              <div className="form-header-action">
                  <Button type="primary" ghost size="large" className="blue-btn ml-20" icon={<FaPen />}> 
                  <Link to="/add-team">
                  تعديل
                  </Link>
                  </Button>
                  <Button 
                    onClick={() => this.setState({showDltModal : true}) }
                   type="primary" danger ghost size="large" icon={ <FaTrash />} className="ml-20">
                 
                  حذف
                  </Button>
                  <Button type="primary" size="large" className="blue-btn" icon={ <FaPlus />}>
                  <Link to="/add-team">
                  موظف جديد 
                  </Link>
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="team-crud-wrapper">
          <div className="container">
            <div className="team-crud-content">
              <div className="team-member-header">
                <p className="team-member-num">عدد موظفين الفريق (12)</p>
                <div className="order-header-search">
                        <Search
                            placeholder="  البحث برقم الموظف او الاسم "
                            // enterButton="Search"
                            size="large"
                        />
                    </div>
              </div>
                <Table
                    loading={tableLoading} 
                    editable
                    style={{marginTop : 0}}
                    pagination={{ simple : true, itemRender : this.itemRender }}  
                    onRow={(record, rowIndex) => {
                        return {
                        onClick: event => {
                            //console.log(record); 
                        }  
                        };
                    }}
                    // rowKey = "id" 
                    className="table-roles-wrapper app-table-wrapper table-hover-wrapper order-table"
                    columns={[
                      {
                        title: `اسم الموظف`, 
                        dataIndex: 'name',
                      },
                      {
                        title: `رقم الجوال`,
                        dataIndex: 'phone',
                      },
                      {
                        title: `البريد الالكتروني`,
                        dataIndex: 'email',
                      }, 
                        {
                            title: `الصلاحيه`,
                            dataIndex: 'totalOrder',
                        },
                        {
                            title: 'حاله الموظف',
                            key: 'action',
                            render: (text, record) => (
                                <Tag className="contact-tag" color="cyan">
                                           متاح
                              </Tag>
                            ),
                          },
                          {
                            title: 'اجراءت',  
                            key: 'action',
                            render: (text, record) => (
                                <Dropdown overlayClassName="action-dropdown-holder" trigger={['click']} overlay={
                                  <Menu>
                                  <Menu.Item className="show-item" icon={<FaEye />}>
                                    <p>عرض </p>
                                  </Menu.Item>
                                  <Menu.Item  icon={<FaPlusSquare />}>
                                    <Link to="/finance">تعديل</Link>
                                  </Menu.Item>
                                  <Menu.Item onClick={() => this.setState({showDltModal : true}) } className="remove-item" icon={<FaTrashAlt />}>
                                    <p>حذف </p>
                                  </Menu.Item>
                                </Menu>
                                } placement="bottomLeft">
                                <div className="dropdown-icon-holder">
                                    <FaEllipsisH  />
                                </div>
                              </Dropdown>
                            ),
                          },
                    ]}
                    dataSource={this.state.nameList}
                />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
